<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-chart`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.778 4C43.005 4 44 4.995 44 6.222v35.556A2.222 2.222 0 0141.778 44H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4h35.556zM40 8H8v32h32V8zM15 20a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V21a1 1 0 011-1h2zm8-6a1 1 0 011 1v20a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2zm8 12a1 1 0 011 1v8a1 1 0 01-1 1h-2a1 1 0 01-1-1v-8a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconChart',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
